import { ContentHeader, LayoutWithNavigationBreadcrumbs } from 'components';
import { useIsFormEditable } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { RoutesId } from 'libs/navigation';
import { Stack } from 'libs/ui';
import {
  FormContent,
  type FormContentProps,
} from 'modules/directory/common/components';

import { EditableFormFooter } from '../FormFooter';
import {
  FormHeaderActions,
  type FormHeaderActionsProps,
} from '../FormHeaderActions';
import { Status } from '../Status';

interface Props extends FormContentProps, FormHeaderActionsProps {
  directoryName?: string;
  submitLoading: boolean;
}

export const DirectoryRecordLayout = ({
  directoryName,
  isArchived,
  isCanEdit,
  onArchive,
  onDearchive,
  fieldsConfig,
  record,
  submitLoading,
}: Props) => {
  const { t } = useTranslation();
  const editable = useIsFormEditable();

  return (
    <LayoutWithNavigationBreadcrumbs
      titles={{
        [RoutesId.directory]: directoryName,
        [RoutesId.directoryRecord]: editable
          ? t('directory.directoryRecord.editTitle')
          : t('directory.directoryRecord.title'),
      }}
    >
      <Stack spacing={24}>
        <ContentHeader
          header={
            editable
              ? t('directory.directoryRecord.editTitle')
              : t('directory.directoryRecord.title')
          }
          headerAfterContent={!editable && <Status isArchived={isArchived} />}
          rightContent={
            <FormHeaderActions
              isArchived={isArchived}
              isCanEdit={isCanEdit}
              onArchive={onArchive}
              onDearchive={onDearchive}
            />
          }
        />
        <FormContent fieldsConfig={fieldsConfig} record={record} />
        <EditableFormFooter submitLoading={submitLoading} />
      </Stack>
    </LayoutWithNavigationBreadcrumbs>
  );
};
